import gql from 'graphql-tag';

export const globalSearchQuery = gql`
  query globalSearchQuery(
    $searchParameters: SearchParametersInput!
    $query: String
    $countryCode: String
  ) {
    searchTags(query: $query, countryCode: $countryCode) {
      total
      results {
        tag
        labels {
          type
          value
        }
        path
      }
    }
    searchEvents(searchParameters: $searchParameters) {
      total
      results {
        title
        slug
        id
        startDate
        place {
          address {
            city
            countryLong
            countryShort
          }
        }
        images {
          hero {
            medium
          }
        }
      }
    }
  }
`;

export const GlobalSearchQueryV2 = gql`
  query globalSearchQuery(
    $searchParameters: SearchParametersInput!
    $query: String!
    $sessionToken: String!
    $countryCode: String
    $latitude: Float
    $longitude: Float
    $radius: Int
  ) {
    searchTags(query: $query, countryCode: $countryCode) {
      total
      results {
        tag
        labels {
          type
          value
        }
        path
      }
    }
    searchEventsV2(searchParameters: $searchParameters) {
      total
      events {
        title
        slug
        id
        startDate
        place {
          address {
            city
            countryLong
            countryShort
          }
        }
        images {
          hero {
            medium
          }
        }
        virtualEventDetails {
          isVirtual
        }
      }
    }
    searchLocations(
      query: $query
      sessionToken: $sessionToken
      lat: $latitude
      lng: $longitude
      radius: $radius
    ) {
      description
      detail {
        address_components {
          short_name
          long_name
          types
        }
        location {
          latitude
          longitude
        }
        viewport {
          northEast {
            latitude
            longitude
          }
          southWest {
            latitude
            longitude
          }
        }
      }
    }
  }
`;
